import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable()
export class ProgressService {
  uploadProgress: Subject<any> = new Subject();
}
